/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { WorkflowUiDefinitionModel } from '@well/iriro-frontend-libs/workflows/domain';
import { WorkflowsStore } from './workflows.store';

@Injectable({
  providedIn: 'root',
})
export class WorkflowsStoreFacadeService {
  private store = inject(WorkflowsStore);
  private injector = inject(Injector);

  // Signal API (new)
  readonly workflowsUiDefinitionSignal = this.store.workflowsUiDefinitionState;
  readonly workflowsDefinitionForFrontendSignal = this.store.workflowsDefinitionForFrontendState;
  readonly workflowsConfigurationsSignal = this.store.workflowsConfigurationsState;

  // Observable API (backward compatible)
  readonly workflowsUiDefinitionState$ = toObservable(this.store.workflowsUiDefinitionState);
  readonly workflowsDefinitionForFrontendState$ = toObservable(this.store.workflowsDefinitionForFrontendState);

  readonly workflowBySystemNameForNewUIDefinitions$ = (name: string) =>
    toObservable(this.store.getWorkflowBySystemNameForNewUIDefinitions(name), { injector: this.injector });

  readonly workflowBySystemName$ = (name: string) =>
    toObservable(this.store.getWorkflowBySystemName(name), { injector: this.injector });

  readonly stepConfiguration$ = (workflowName: string, stepId: string) =>
    toObservable(this.store.getStepConfiguration(workflowName, stepId), { injector: this.injector });

  addFrontEndDefinitions(workflows: Record<string, WorkflowUiDefinitionModel>) {
    this.store.addFrontEndDefinitions(workflows);
  }

  fetchAllConfigurations() {
    this.store.loadWorkflowsConfiguration();
  }

  clearAllConfigurations() {
    this.store.clearAllConfigurations();
  }
}
